var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.139 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.016 18l.889-5.791h-5.557V8.451c0-1.584.776-3.129 3.265-3.129h2.526V.391A30.807 30.807 0 0012.655 0C8.079 0 5.091 2.774 5.091 7.8v4.414H0V18h5.091v14h6.261V18z",
    fill: "currentColor"
  })));
}
export default SvgFacebookFull;